import React from 'react';
import Icon from '.';

const ChevronThinLeftIcon = props => (
	<Icon viewBox="0 0 24 24" {...props}>
		<defs>
			<path d="M4 18v-2h10V6h2v12H4z" id="ChevronThinLeft_svg__a" />
		</defs>
		<g fill="currentColor" fillRule="evenodd">
			<mask id="ChevronThinLeft_svg__b" fill="#fff">
				<use xlinkHref="#ChevronThinLeft_svg__a" />
			</mask>
			<use transform="rotate(135 10 12)" xlinkHref="#ChevronThinLeft_svg__a" />
		</g>
	</Icon>
);

export default ChevronThinLeftIcon;
